import { render, staticRenderFns } from "./SimpleSlider.vue?vue&type=template&id=66095686&scoped=true&"
import script from "./SimpleSlider.vue?vue&type=script&lang=js&"
export * from "./SimpleSlider.vue?vue&type=script&lang=js&"
import style0 from "./SimpleSlider.vue?vue&type=style&index=0&id=66095686&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66095686",
  null
  
)

export default component.exports